export enum TenantedDeploymentMode {
    Untenanted = "Untenanted",
    TenantedOrUntenanted = "TenantedOrUntenanted",
    Tenanted = "Tenanted",
}

export default TenantedDeploymentMode;